export default {
    'it-IT': {
        outdoorTips: 'Outdoor tips', //temi  generici + consigli + errori da non fare
        cyclingTips: 'Cycling tips', //temi  generici + consigli + errori da non fare
        mustHave: 'Must-have', // prodotti in base a tematiche/stagionali
        howtos: 'How to', // tutorial (tecnici) / video YT Fabio
        reviews: 'Reviews', // // tutorial (tecnici) / video YT Fabio
        runkdTips: 'Runkd Tips',
        inwildTips: 'Inwild Tips',
        latest: 'Ultimi articoli',
        title: 'Top news',
    },
    'fr-FR': {
        outdoorTips: 'Outdoor tips', //temi  generici + consigli + errori da non fare
        cyclingTips: 'Cycling tips', //temi  generici + consigli + errori da non fare
        mustHave: 'Must-have', // prodotti in base a tematiche/stagionali
        howtos: 'How to', // tutorial (tecnici) / video YT Fabio
        reviews: 'Reviews', // // tutorial (tecnici) / video YT Fabio
        runkdTips: 'Runkd Tips',
        inwildTips: 'Inwild Tips',
        latest: '',
        title: 'Top news',
    },
    'es-ES': {
        outdoorTips: 'Outdoor tips', //temi  generici + consigli + errori da non fare
        cyclingTips: 'Cycling tips', //temi  generici + consigli + errori da non fare
        mustHave: 'Must-have', // prodotti in base a tematiche/stagionali
        howtos: 'How to', // tutorial (tecnici) / video YT Fabio
        reviews: 'Reviews', // // tutorial (tecnici) / video YT Fabio
        runkdTips: 'Runkd Tips',
        inwildTips: 'Inwild Tips',
        latest: 'Artículos más recientes',
        title: 'Top news',
    },
    'en-GB': {
        outdoorTips: 'Outdoor tips', //temi  generici + consigli + errori da non fare
        cyclingTips: 'Cycling tips', //temi  generici + consigli + errori da non fare
        mustHave: 'Must-have', // prodotti in base a tematiche/stagionali
        howtos: 'How to', // tutorial (tecnici) / video YT Fabio
        reviews: 'Reviews', // // tutorial (tecnici) / video YT Fabio
        runkdTips: 'Runkd Tips',
        inwildTips: 'Inwild Tips',
        latest: 'Latest articles',
        title: 'Top news',
    },
    'en-US': {
        outdoorTips: 'Outdoor tips', //temi  generici + consigli + errori da non fare
        cyclingTips: 'Cycling tips', //temi  generici + consigli + errori da non fare
        mustHave: 'Must-have', // prodotti in base a tematiche/stagionali
        howtos: 'How to', // tutorial (tecnici) / video YT Fabio
        reviews: 'Reviews', // // tutorial (tecnici) / video YT Fabio
        runkdTips: 'Runkd Tips',
        inwildTips: 'Inwild Tips',
        latest: 'Latest articles',
        title: 'Top news',
    },
    'de-DE': {
        outdoorTips: 'Outdoor tips', //temi  generici + consigli + errori da non fare
        cyclingTips: 'Cycling tips', //temi  generici + consigli + errori da non fare
        mustHave: 'Must-have', // prodotti in base a tematiche/stagionali
        howtos: 'How to', // tutorial (tecnici) / video YT Fabio
        reviews: 'Reviews', // // tutorial (tecnici) / video YT Fabio
        runkdTips: 'Runkd Tips',
        inwildTips: 'Inwild Tips',
        latest: 'Neueste Blog-Artikel',
        title: 'Top news',
    },
    'en-AU': {
        outdoorTips: 'Outdoor tips', //temi  generici + consigli + errori da non fare
        cyclingTips: 'Cycling tips', //temi  generici + consigli + errori da non fare
        mustHave: 'Must-have', // prodotti in base a tematiche/stagionali
        howtos: 'How to', // tutorial (tecnici) / video YT Fabio
        reviews: 'Reviews', // // tutorial (tecnici) / video YT Fabio
        runkdTips: 'Runkd Tips',
        inwildTips: 'Inwild Tips',
        latest: 'Latest articles',
        title: 'Top news',
    },
    'ko-KR': {
        outdoorTips: 'Outdoor tips', //temi  generici + consigli + errori da non fare
        cyclingTips: 'Cycling tips', //temi  generici + consigli + errori da non fare
        mustHave: 'Must-have', // prodotti in base a tematiche/stagionali
        howtos: 'How to', // tutorial (tecnici) / video YT Fabio
        reviews: 'Reviews', // // tutorial (tecnici) / video YT Fabio
        runkdTips: 'Runkd Tips',
        inwildTips: 'Inwild Tips',
        latest: 'Latest articles',
        title: 'Top news',
    },
};
